import { Fire, Timer, Barbell, TrendUp, ShareNetwork } from '@phosphor-icons/react';

export default function StatsGrid({ streak, stats, onShareClick }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      <div className="tactical-card p-5 relative group" data-testid="streak-widget">
        <Fire weight="fill" className="w-8 h-8 text-[#FF3B30] mb-3" />
        <div className="text-3xl font-black font-['Barlow_Condensed']">{streak.current_streak || 0}</div>
        <div className="label-tactical mt-1">Day Streak</div>
        {streak.longest_streak > 0 && (
          <div className="text-xs text-[#71717A] mt-1">Best: {streak.longest_streak} days</div>
        )}
        <button
          onClick={onShareClick}
          className="absolute top-3 right-3 p-1.5 bg-[#FF3B30]/10 border border-[#FF3B30]/20 text-[#FF3B30] opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#FF3B30]/20"
          data-testid="share-streak-trigger"
          title="Share your streak"
        >
          <ShareNetwork weight="bold" className="w-4 h-4" />
        </button>
      </div>
      <div className="tactical-card p-5" data-testid="workouts-week-widget">
        <Barbell weight="bold" className="w-8 h-8 text-[#007AFF] mb-3" />
        <div className="text-3xl font-black font-['Barlow_Condensed']">{stats?.workouts_this_week || 0}</div>
        <div className="label-tactical mt-1">This Week</div>
      </div>
      <div className="tactical-card p-5" data-testid="minutes-widget">
        <Timer weight="bold" className="w-8 h-8 text-[#34C759] mb-3" />
        <div className="text-3xl font-black font-['Barlow_Condensed']">{stats?.total_minutes_this_week || 0}</div>
        <div className="label-tactical mt-1">Minutes</div>
      </div>
      <div className="tactical-card p-5" data-testid="total-workouts-widget">
        <TrendUp weight="bold" className="w-8 h-8 text-[#FF9500] mb-3" />
        <div className="text-3xl font-black font-['Barlow_Condensed']">{streak.total_workouts || 0}</div>
        <div className="label-tactical mt-1">Total Workouts</div>
      </div>
    </div>
  );
}
